/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class ImageUploader {
    restrict = 'E';
    scope = {
      selectedImage: "="
    };
    templateUrl = "app/components/controls/imageSelectorTemplate.html";
    constructor() {

    }
    link = (scope: any, element: angular.IAugmentedJQuery, attrs: any, ngModel: angular.INgModelController) => {
     

    }
    static factory(): angular.IDirectiveFactory {
      let directive = () => {
        return new ImageUploader();
      };

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("imageSelector", ImageUploader.factory());
}